export default {
  base: {
    color: 'primary-yellow-100'
  }
};